export default __webpack_public_path__ + "static/fruskogorski-maraton1-89707e4c666b52d97a7d7cf96a40e88e.png";